export default {
  0: { background: "#ff8a80", color: "#9b0000" },
  1: { background: "#ffd180", color: "#c43c00" },
  2: { background: "#8c9eff", color: "#0026ca" },
  3: { background: "#73ff7a", color: "#165224" },
  4: { background: "#ff80ab", color: "#8e0038" },
  5: { background: "#ffc79f", color: "#8e0038" }, 
  6: { background: "#80d8ff", color: "#0064b7" },
  7: { background: "#b0bec5", color: "#34515e" },
  8: { background: "#ea80fc", color: "#7200ca" },
  9: { background: "#b388ff", color: "#0a00b6" },
  10: { background: "#a7ffeb", color: "#008e76" },
  11: { background: "#ffe57f", color: "#c67c00" },
  12: { background: "#b9f6ca", color: "#009624" },
  13: { background: "#f4ff81", color: "#79b700" },
  14: { background: "#84ffff", color: "#0088a3" },
  15: { background: "#bcaaa4", color: "#4b2c20" },
  16: { background: "#82b1ff", color: "#0039cb" },
  17: { background: "#bdbdbd", color: "#373737" },
  18: { background: "#ff7075", color: "#761a23" },
  19: { background: "#ccff90", color: "#1faa00" },
  20: { background: "#ffff8d", color: "#c7a500" },
  21: { background: "#83bced", color: "#295574" },
  22: { background: "#bfd8c5", color: "#3e4b42" },
  23: { background: "#d3b8b8", color: "#504141" },
  24: { background: "#f9758d", color: "#882940" }
};
